import { HTTPRequestMethods } from '@enums/HTTPRequestMethods'
import { HeaderContentType } from '@enums/HeaderContentType'
import { DEFAULT_REQUEST_OPTIONS_TIMEOUT } from '@constants/times'

interface IRequestOptions {
  method?: HTTPRequestMethods
  headers?: Record<string, string>
  timeout?: number
  body?: Object
}

export function createRequestOptions({
  method = HTTPRequestMethods.POST,
  body,
  headers = {},
  timeout = DEFAULT_REQUEST_OPTIONS_TIMEOUT,
}: IRequestOptions) {
  const options: IRequestOptions = {
    method,
    headers: {
      'Content-Type': HeaderContentType.JSON,
      ...headers,
    },
    ...(body ? { body: JSON.stringify(body) } : {}),
    timeout,
  }
  return options
}
